import { ShareholderItem } from "api"
import { ArcElement, Chart as ChartJS, ChartOptions } from "chart.js"
import "chart.js/auto"
import ChartDataLabels from "chartjs-plugin-datalabels"
import { Mobile } from "common/MediaQueries"
import { useTranslations } from "next-intl"
import { Doughnut, Pie } from "react-chartjs-2"
import styled from "styled-components"

ChartJS.register(ArcElement, ChartDataLabels)
ChartJS.defaults.plugins.datalabels.align = "end"
ChartJS.defaults.plugins.datalabels.anchor = "end"

export type SharedHoldersChartDataProps = {
  dataSharedHolders: ShareholderItem[]
}

const SharedHoldersChartWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  ${(p) => p.theme.breakpoints.up("md")} {
    height: 300px;
    width: 400px;
  }
`

const StyledDoughnutWrapper = styled.div`
  width: 356px;
  height: 356px;

  position: absolute;
  top: 0;
  direction: ltr;

  ${(p) => p.theme.breakpoints.up("md")} {
    width: 400px;
    height: 400px;
  }
`

const StyledPieWrapper = styled.div`
  width: 50px;
  height: 40px;
  position: absolute;
  top: 154px;

  ${(p) => p.theme.breakpoints.up("md")} {
    height: 70px;
    width: 70px;
    top: 165px;
  }
`

const SharedHoldersChart = ({
  dataSharedHolders,
}: SharedHoldersChartDataProps) => {
  const t = useTranslations("shareholders")
  const labels = dataSharedHolders?.map(
    (sharedHolder) =>
      sharedHolder.shareholderName.value.split(" ").join("\n") +
      "\n" +
      sharedHolder.sharePercentage.value +
      "%"
  )

  const dataChart = {
    labels: labels,
    datasets: [
      {
        data: dataSharedHolders?.map((sharedNumber) =>
          parseInt(sharedNumber.sharePercentage?.value)
        ),
        backgroundColor: dataSharedHolders?.map(
          (dataSharedHolder, i) =>
            "rgba(217, 0, 29," +
            (1 / dataSharedHolders?.length) *
              ((dataSharedHolders?.length || 0) - i) +
            ")"
        ),
        borderColor: "transparent",
      },
    ],
  }

  const chartOptions: ChartOptions<"doughnut"> = {
    rotation: 0,
    layout: {
      padding: Mobile ? 100 : 140,
    },
    // display: false,
    plugins: {
      legend: { display: false },

      datalabels: {
        font: {
          size: 12,
          family: "FbJabutinskiEng, FbJabutinski",
        },
        // display: "auto",
        textAlign: "center",
        padding: { left: 20 },
        offset: Mobile ? 20 : 15,
        formatter: function (value, context) {
          return context.chart.data.labels[context.dataIndex] || null
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return context.label
          },
        },
      },
    },
  }
  const pieOptions = {
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
      datalabels: {
        formatter: function () {
          return null
        },
        display: "auto",
      },
    },
  }

  // add this plugins in properties of doughnut: <Doughnut redraw data={dataChart} options={chartOptions} plugins={plugins}  />
  // const plugins = [
  //   {
  //     beforeInit: function (chart) {
  //       chart.data.labels.forEach(function (e, i, a) {
  //         if (/\n/.test(e)) {
  //           a[i] = e.split(/\n/);
  //         }
  //       });
  //     },
  //   },
  // ];

  return (
    <SharedHoldersChartWrapper>
      <StyledPieWrapper>
        <Pie data={dataChart} options={pieOptions} />
      </StyledPieWrapper>
      <StyledDoughnutWrapper>
        <Doughnut
          redraw
          data={dataChart}
          options={chartOptions}
          aria-label={t("canvasAria")}
        />
      </StyledDoughnutWrapper>
    </SharedHoldersChartWrapper>
  )
}

export default SharedHoldersChart
